import styled from 'styled-components';
import getConfig from 'next/config';
import GoogleMapReact from 'google-map-react';
import Marker from './partials/Marker.GoogleMap';
import { gridGutter, mq } from '~/styles/grid';

const Wrapper = styled.div`
  height: 450px;
  width: 100%;
  margin: 25px 0 55px;
  overflow: hidden;

  @media (${mq.xs}) {
    width: calc(100% + ${gridGutter * 2}px);
    margin: 25px -${gridGutter}px 55px;
  }
`;

/**
 * @param {GoogleMapProps} props
 * @returns {React.ReactElement} The rendered component
 */
const GoogleMap = ({
  mapCenter,
  locations,
  clusters,
  searchZoom,
  onZoomChange,
  handleBounds,
  markerOnClick,
}) => {
  const defaultProps = {
    center: mapCenter,
    zoom: searchZoom,
  };

  const { publicRuntimeConfig } = getConfig();

  /**
   * @param {number} mapZoom
   */
  const handleZoomChange = (mapZoom) => {
    if (mapZoom !== defaultProps.zoom) {
      onZoomChange(mapZoom);
    }
  };

  return (
    <Wrapper>
      <GoogleMapReact
        bootstrapURLKeys={{ key: publicRuntimeConfig.googleMapApi }}
        defaultCenter={defaultProps.center}
        defaultZoom={defaultProps.zoom}
        onChange={({ zoom, bounds, center }) => {
          handleZoomChange(zoom);
          handleBounds(
            {
              swLat: bounds.sw.lat,
              swLng: bounds.sw.lng,
              neLng: bounds.ne.lng,
              neLat: bounds.ne.lat,
            },
            zoom,
            center,
          );
        }}
      >
        {locations &&
          locations.length > 0 &&
          locations.map((location, idx) => {
            return (
              <Marker
                key={idx}
                count={1}
                lng={location.longitude}
                lat={location.latitude}
                onClick={(lat, lng) => markerOnClick(lat, lng)}
              />
            );
          })}
        {clusters &&
          clusters.length > 0 &&
          clusters.map((cluster, idx) => {
            return (
              <Marker
                key={idx}
                count={cluster.count}
                lng={cluster.center.longitude}
                lat={cluster.center.latitude}
                onClick={(lat, lng) => markerOnClick(lat, lng)}
              />
            );
          })}
      </GoogleMapReact>
    </Wrapper>
  );
};

export default GoogleMap;
